<template>
  <div>
    <pc-header></pc-header>
    <div class="header-wrap">
      <img src="@/assets/images/news/news-head-bg.png" />
    </div>

    <div class="content-wrap">
      <div class="title">明年3月起微信支付宝收款码禁止商用系误读</div>
      <div class="time">2021-11-26 14:09</div>
      <div id="img-content" class="rich_media_wrp">
        <div class="rich_media_content " id="js_content" style="visibility: visible;">
          <img style="margin-top:20px" src="../../../assets/images/news/news-info.webp" alt="">
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;"><br></p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">#明年3月1日起，微信支付宝收款码将不能用于经营收款#上热搜了</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">&nbsp;</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">其实这个话题昨天就在圈内刷屏，今天所有正规媒体也突然跟进，所有“支付概念股”也闻声大涨，但同时，这个标题也给很多普通人带来一些误解。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">&nbsp;</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">普通人误认为微信支付宝收款码不能用了。但事实并非如此。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">&nbsp;</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <strong>
              <span style="font-size: 15px;">误解一：并非以后就不能用了，只要完成从个人到商户的“升级”就能继续用。</span>
            </strong>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <strong>
              <span style="font-size: 15px;"><br></span>
            </strong>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <strong>
              <span style="font-size: 15px;">误解二：不是所有收款码，而是专指“个人静态收款码”</span>
            </strong>
            <span style="font-size: 15px;"></span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;"><br></span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">今年10月13日人民银行发布了
              <a target="_blank" href="http://mp.weixin.qq.com/s?__biz=MzI3MDA5NjgzOQ==&amp;mid=2650117661&amp;idx=2&amp;sn=b025f311da650804703a2573f9034d7b&amp;chksm=f2d776b5c5a0ffa343423742e40c80c43a023be190050116a513388dd462c59ed8eabffcde4c&amp;scene=21#wechat_redirect" textvalue="《中国人民银行关于加强支付受理终端及相关业务管理的通知》" linktype="text" imgurl="" imgdata="null" data-itemshowtype="0" tab="innerlink" data-linktype="2" wah-hotarea="click" hasload="1">《中国人民银行关于加强支付受理终端及相关业务管理的通知》</a>（以下简称《通知》），以下简称为《通知》。在这份《通知》发布后央行有关部门负责人在答记者问“《通知》如何规范个人收款条码”的环节特意提到了“时间节点”。回答如下：</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;"><br></span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="color: rgb(136, 136, 136);font-size: 15px;">1、为了确保个人收款条码相关要求有效落地、业务平稳过渡，《通知》设置了过渡期，要求支付服务主体全面、充分评估客户正常支付需求，制定配套服务解决方案，做好客户引导和服务工作，确保服务成本不升、质量不降。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;color: rgb(136, 136, 136);">&nbsp;</span>
          </p>
          <section style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;color: rgb(136, 136, 136);">2、《
              <span style="color: rgb(136, 136, 136);font-size: 15px;">通</span>
              <span style="color: rgb(136, 136, 136);font-size: 15px;">知</span>》中明确：收单机构应当自本通知发布之日起1年内完成全部存量特约商户身份信息核实工作，形成工作报告备查。</span>
          </section>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;color: rgb(136, 136, 136);"><br></span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">所以报道中提到的“明年3月1日起”这个时间节点是不严谨的，微信支付宝两方需要时间来制定解决方案，而监管也设置了“过渡期”，具体时间肯定是做好了解决方案后，再进行有序平稳的推进，最后才能达成。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">&nbsp;</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">很多《报道》起的标题给普通人的感觉都是“微信支付宝收款码”不能用了，但实际上只要微信支付宝解决方案做的好，普通人几乎是无感就能完成从个人到商户的“升级”。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">&nbsp;</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">这里我们按照支付行业产品升级的流程做个推测，首先是系统甄别，哪些用户的个人收款码具有经营特征，甄别出来后，在手机app端提示用户“升级”个人收款码，用户点击升级提交“商户资料”核实完成后即可完成升级，用户的个人收款码就能继续使用。对此《通知》中也有提示：</span>
            <span style="font-size: 15px;color: rgb(136, 136, 136);">对于无固定经营场所的实体特约商户和网络特约商户，原则上应当通过人工或智能客服同步视频等方式核实。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;color: rgb(136, 136, 136);">&nbsp;</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">最后需要强调的是在《报道》中提到的“微信支付宝个人收款码”，《通知》中明确：</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">&nbsp;</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;color: rgb(136, 136, 136);">对于为个人或特约商户等收款人生成的，用于付款人识读并发起支付指令的收款条码，银行、支付机构、清算机构等为收款人提供收款条码相关支付服务的机构（以下统称条码支付收款服务机构）应当制定收款条码分类管理制度，有效区分个人和特约商户使用收款条码的场景和用途，防范收款条码被出租、出借、出售或用于违法违规活动。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;color: rgb(136, 136, 136);"><br></span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;color: rgb(0, 82, 255);">对于具有明显经营活动特征的个人，条码支付收款服务机构应当为其提供特约商户收款条码，并参照执行特约商户有关管理规定，不得通过个人收款条码为其提供经营活动相关收款服务。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;color: rgb(136, 136, 136);"><br></span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;color: rgb(0, 82, 255);">条码支付收款服务机构应当采取有效措施禁止个人静态收款条码被用于远程非面对面收款。</span>
            <span style="color: rgb(136, 136, 136);font-size: 15px;">确有必要进行远程非面对面收款的，条码支付收款服务机构应当对相应收款人实行白名单管理，并审慎确定白名单准入条件与规模、个人静态收款条码的有效期、使用次数和交易限额。对于通过截屏、下载等方式保存的个人动态收款条码，应当参照执行个人静态收款条码有关规定。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">&nbsp;</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">也就说，个人静态收款码会有几点限制。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">&nbsp;</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">限制一：个人静态收款码不能用于非面对面的收款，不能用于远程的收款；</span>
            <span style="font-size: 15px;">有非面对面和远程收款需求的，可以申请白名单，白名单也有相应限制。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;"><br></span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">限制二：个人动态收款码，如果通过截屏下载保存，则视为静态码进行管理。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;"><br></span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">限制三：个人静态收款码如果有经营特征，必须完成从个人到商户的升级。这个取决于微信支付宝平台方提供的解决方案来引导。</span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;"><br></span>
          </p>
          <p style="line-height: 2em;margin-left: 16px;margin-right: 16px;">
            <span style="font-size: 15px;">按照POS圈支付网的理解，个人收款码不能用于经营收款这没错，但不代表不能升级，只要完成个人到商户的升级应该不影响“小微”继续使用。而整个升级过程，应该会同个人做实名认证一样简单，普通人更是会毫无感知。</span>
            <span style="font-size: 15px;">但最终的解决方案</span>
            <span style="font-size: 15px;">取决于微信</span>
            <span style="font-size: 15px;">支付宝平台</span>
            <span style="font-size: 15px;">。</span>
          </p>
        </div>
      </div>
    </div>
    <pc-footer></pc-footer>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {}
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.header-wrap {
  // margin-top: -60px;
}
img {
  width: 100%;
  object-fit: cover;
}

.content-wrap {
  padding-top: 50px;
  padding-bottom: 50px;
  width: 900px;
  margin: 0 auto;

  .title {
    font-size: 32px;
    font-weight: bold;
    line-height: 38px;
    color: #000000;
    opacity: 0.85;
    text-align: center;
  }
  .time {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: #a8a8a8;
    margin-top: 15px;
    text-align: center;
  }
  .rich_media_content {
    overflow: hidden;
    color: #333;
    font-size: 17px;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    text-align: justify;
    position: relative;
    z-index: 0;
  }
  .rich_media_content p {
    clear: both;
    min-height: 1em;
  }
}
</style>